module.exports = __webpack_public_path__ + "img/blockchain.d0e1408c.png";